/**
 * P23 PR 2 – Ký điện tử dùng chung (docs/phases/P23.md, DEC-458).
 * Hồ sơ trình ký: PDF gốc khóa bằng mã băm; người ký theo thứ tự; ký xong ERP ghép trang xác thực + QR tra cứu /xac-thuc/<mã>.
 */
export const ESIGN_DOC_TYPES = ['general', 'internal', 'handover', 'acceptance', 'inspection', 'liquidation', 'purchase_contract', 'sales_contract', 'letter', 'authorization'] as const;
export type EsignDocType = (typeof ESIGN_DOC_TYPES)[number];
export const ESIGN_DOC_TYPE_LABELS: Record<EsignDocType, string> = {
  general: 'Văn bản khác',
  internal: 'Văn bản nội bộ (quyết định, thông báo)',
  handover: 'Biên bản bàn giao hàng hóa, thiết bị',
  acceptance: 'Biên bản nghiệm thu công trình',
  inspection: 'Hồ sơ kiểm định thiết bị PCCC',
  liquidation: 'Biên bản thanh lý hợp đồng',
  purchase_contract: 'Hợp đồng mua (NCC, thầu phụ)',
  sales_contract: 'Hợp đồng bán',
  letter: 'Công văn gửi khách, NCC',
  authorization: 'Giấy ủy quyền',
};
/** Loại người dùng tự chọn khi trình ký (giấy ủy quyền do màn Quyền ký tự lập). */
export const ESIGN_UPLOAD_DOC_TYPES = ESIGN_DOC_TYPES.filter((t) => t !== 'authorization');

export const ESIGN_STATUSES = ['pending', 'signed', 'refused', 'cancelled'] as const;
export type EsignStatus = (typeof ESIGN_STATUSES)[number];
export const ESIGN_STATUS_LABELS: Record<EsignStatus, string> = {
  pending: 'Đang chờ ký',
  signed: 'Đã ký xong',
  refused: 'Bị từ chối ký',
  cancelled: 'Đã rút',
};

/** company = ký cho công ty (cần quyền ký); personal = NV ký phần của mình (nhận, xác nhận); counterparty = khách / NCC / đối tác. */
export const ESIGN_SIDES = ['company', 'personal', 'counterparty'] as const;
export type EsignSide = (typeof ESIGN_SIDES)[number];
export const ESIGN_SIDE_LABELS: Record<EsignSide, string> = {
  company: 'Ký cho công ty',
  personal: 'Ký cá nhân',
  counterparty: 'Khách / NCC / đối tác',
};

export const ESIGN_METHODS = ['saved', 'link', 'onsite', 'paper'] as const;
export type EsignMethod = (typeof ESIGN_METHODS)[number];
export const ESIGN_METHOD_LABELS: Record<EsignMethod, string> = {
  saved: 'Chữ ký mẫu + mật khẩu ERP',
  link: 'Ký qua link',
  onsite: 'Ký tại chỗ trên điện thoại NV',
  paper: 'Ký giấy, chụp ảnh tải lên',
};

/** Link ký cho khách / NCC hết hạn sau 7 ngày (cấp lại được). */
export const ESIGN_LINK_DAYS = 7;
export const ESIGN_MAX_PARTIES = 10;
